export default __webpack_public_path__ + "static/media/WStore_Icon_Chicago.ded469d6.png";